export const clearLocalStorage = localStorageKey => {
  try {
    localStorageKey && localStorage.removeItem(localStorageKey)
  } catch (e) {
    // do nothing
  }
}

export const saveToLocalStorage = (localStorageKey, data) => {
  try {
    localStorageKey && localStorage.setItem(localStorageKey, JSON.stringify(data))
  } catch (e) {
    // do nothing
  }
}

export const loadFromLocalStorage = (localStorageKey, defaultValue = {}) => {
  try {
    return JSON.parse((localStorageKey && localStorage.getItem(localStorageKey)) || '{}')
  } catch (e) {
    return defaultValue
  }
}
